/**
 * Generated by orval v8.11.0 🍺
 * Do not edit manually.
 * Core API
 * Core API Documentation
 * OpenAPI spec version: 1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  AddNurseryMemberCommandControllerAddMember201,
  AddNurseryMemberDto,
  AddNurseryStaffCommandControllerAddStaff201,
  AddNurseryStaffDto,
  ListNurseryMembersQueryControllerListMembersParams,
  ListNurseryMembersResponseDto,
  NurseryMemberDto,
  UpdateMemberRoleDto,
} from "../model";

import { axiosClient } from "../../lib/api";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

/**
 * Platform admins only: it attaches any existing user by id. Staff are added through POST /v1/nurseries/:nurseryId/staff.
 * @summary Add a member to a nursery
 */
export const addNurseryMemberCommandControllerAddMember = (
  nurseryId: string,
  addNurseryMemberDto: AddNurseryMemberDto,
  signal?: AbortSignal,
) => {
  return axiosClient<AddNurseryMemberCommandControllerAddMember201>({
    url: `/v1/nurseries/${nurseryId}/members`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: addNurseryMemberDto,
    signal,
  });
};

export const getAddNurseryMemberCommandControllerAddMemberMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addNurseryMemberCommandControllerAddMember>>,
    TError,
    { nurseryId: string; data: AddNurseryMemberDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addNurseryMemberCommandControllerAddMember>>,
  TError,
  { nurseryId: string; data: AddNurseryMemberDto },
  TContext
> => {
  const mutationKey = ["addNurseryMemberCommandControllerAddMember"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addNurseryMemberCommandControllerAddMember>>,
    { nurseryId: string; data: AddNurseryMemberDto }
  > = (props) => {
    const { nurseryId, data } = props ?? {};

    return addNurseryMemberCommandControllerAddMember(nurseryId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AddNurseryMemberCommandControllerAddMemberMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof addNurseryMemberCommandControllerAddMember>>
  >;
export type AddNurseryMemberCommandControllerAddMemberMutationBody =
  AddNurseryMemberDto;
export type AddNurseryMemberCommandControllerAddMemberMutationError = void;

/**
 * @summary Add a member to a nursery
 */
export const useAddNurseryMemberCommandControllerAddMember = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof addNurseryMemberCommandControllerAddMember>>,
      TError,
      { nurseryId: string; data: AddNurseryMemberDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof addNurseryMemberCommandControllerAddMember>>,
  TError,
  { nurseryId: string; data: AddNurseryMemberDto },
  TContext
> => {
  return useMutation(
    getAddNurseryMemberCommandControllerAddMemberMutationOptions(options),
    queryClient,
  );
};
/**
 * This endpoint creates a new user account if the email does not exist, then adds them as a nursery member. If the user already exists, it simply adds them to the nursery.
 * @summary Add staff member to a nursery (creates user if needed)
 */
export const addNurseryStaffCommandControllerAddStaff = (
  nurseryId: string,
  addNurseryStaffDto: AddNurseryStaffDto,
  signal?: AbortSignal,
) => {
  return axiosClient<AddNurseryStaffCommandControllerAddStaff201>({
    url: `/v1/nurseries/${nurseryId}/staff`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: addNurseryStaffDto,
    signal,
  });
};

export const getAddNurseryStaffCommandControllerAddStaffMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addNurseryStaffCommandControllerAddStaff>>,
    TError,
    { nurseryId: string; data: AddNurseryStaffDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addNurseryStaffCommandControllerAddStaff>>,
  TError,
  { nurseryId: string; data: AddNurseryStaffDto },
  TContext
> => {
  const mutationKey = ["addNurseryStaffCommandControllerAddStaff"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addNurseryStaffCommandControllerAddStaff>>,
    { nurseryId: string; data: AddNurseryStaffDto }
  > = (props) => {
    const { nurseryId, data } = props ?? {};

    return addNurseryStaffCommandControllerAddStaff(nurseryId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AddNurseryStaffCommandControllerAddStaffMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof addNurseryStaffCommandControllerAddStaff>>
  >;
export type AddNurseryStaffCommandControllerAddStaffMutationBody =
  AddNurseryStaffDto;
export type AddNurseryStaffCommandControllerAddStaffMutationError = void;

/**
 * @summary Add staff member to a nursery (creates user if needed)
 */
export const useAddNurseryStaffCommandControllerAddStaff = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof addNurseryStaffCommandControllerAddStaff>>,
      TError,
      { nurseryId: string; data: AddNurseryStaffDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof addNurseryStaffCommandControllerAddStaff>>,
  TError,
  { nurseryId: string; data: AddNurseryStaffDto },
  TContext
> => {
  return useMutation(
    getAddNurseryStaffCommandControllerAddStaffMutationOptions(options),
    queryClient,
  );
};
/**
 * @summary Remove a member from a nursery
 */
export const removeNurseryMemberCommandControllerRemoveMember = (
  nurseryId: string,
  userId: string,
  signal?: AbortSignal,
) => {
  return axiosClient<void>({
    url: `/v1/nurseries/${nurseryId}/members/${userId}`,
    method: "DELETE",
    signal,
  });
};

export const getRemoveNurseryMemberCommandControllerRemoveMemberMutationOptions =
  <TError = void, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof removeNurseryMemberCommandControllerRemoveMember>
      >,
      TError,
      { nurseryId: string; userId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof removeNurseryMemberCommandControllerRemoveMember>
    >,
    TError,
    { nurseryId: string; userId: string },
    TContext
  > => {
    const mutationKey = ["removeNurseryMemberCommandControllerRemoveMember"];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof removeNurseryMemberCommandControllerRemoveMember>
      >,
      { nurseryId: string; userId: string }
    > = (props) => {
      const { nurseryId, userId } = props ?? {};

      return removeNurseryMemberCommandControllerRemoveMember(
        nurseryId,
        userId,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type RemoveNurseryMemberCommandControllerRemoveMemberMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof removeNurseryMemberCommandControllerRemoveMember>>
  >;

export type RemoveNurseryMemberCommandControllerRemoveMemberMutationError =
  void;

/**
 * @summary Remove a member from a nursery
 */
export const useRemoveNurseryMemberCommandControllerRemoveMember = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof removeNurseryMemberCommandControllerRemoveMember>
      >,
      TError,
      { nurseryId: string; userId: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof removeNurseryMemberCommandControllerRemoveMember>>,
  TError,
  { nurseryId: string; userId: string },
  TContext
> => {
  return useMutation(
    getRemoveNurseryMemberCommandControllerRemoveMemberMutationOptions(options),
    queryClient,
  );
};
/**
 * Organisation admins and nursery managers can update member roles. Managers cannot change a manager's role or promote anyone to manager. Nobody may change their own role.
 * @summary Update a nursery member role
 */
export const updateMemberRoleCommandControllerUpdateMemberRole = (
  nurseryId: string,
  userId: string,
  updateMemberRoleDto: UpdateMemberRoleDto,
  signal?: AbortSignal,
) => {
  return axiosClient<void>({
    url: `/v1/nurseries/${nurseryId}/members/${userId}/role`,
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    data: updateMemberRoleDto,
    signal,
  });
};

export const getUpdateMemberRoleCommandControllerUpdateMemberRoleMutationOptions =
  <TError = void, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof updateMemberRoleCommandControllerUpdateMemberRole>
      >,
      TError,
      { nurseryId: string; userId: string; data: UpdateMemberRoleDto },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof updateMemberRoleCommandControllerUpdateMemberRole>
    >,
    TError,
    { nurseryId: string; userId: string; data: UpdateMemberRoleDto },
    TContext
  > => {
    const mutationKey = ["updateMemberRoleCommandControllerUpdateMemberRole"];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof updateMemberRoleCommandControllerUpdateMemberRole>
      >,
      { nurseryId: string; userId: string; data: UpdateMemberRoleDto }
    > = (props) => {
      const { nurseryId, userId, data } = props ?? {};

      return updateMemberRoleCommandControllerUpdateMemberRole(
        nurseryId,
        userId,
        data,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateMemberRoleCommandControllerUpdateMemberRoleMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof updateMemberRoleCommandControllerUpdateMemberRole>
    >
  >;
export type UpdateMemberRoleCommandControllerUpdateMemberRoleMutationBody =
  UpdateMemberRoleDto;
export type UpdateMemberRoleCommandControllerUpdateMemberRoleMutationError =
  void;

/**
 * @summary Update a nursery member role
 */
export const useUpdateMemberRoleCommandControllerUpdateMemberRole = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof updateMemberRoleCommandControllerUpdateMemberRole>
      >,
      TError,
      { nurseryId: string; userId: string; data: UpdateMemberRoleDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateMemberRoleCommandControllerUpdateMemberRole>>,
  TError,
  { nurseryId: string; userId: string; data: UpdateMemberRoleDto },
  TContext
> => {
  return useMutation(
    getUpdateMemberRoleCommandControllerUpdateMemberRoleMutationOptions(
      options,
    ),
    queryClient,
  );
};
/**
 * Returns a paginated list of nursery members the user has access to. Supports filtering by organisation, nursery, role, and search.
 * @summary List nursery members
 */
export const listNurseryMembersQueryControllerListMembers = (
  params?: ListNurseryMembersQueryControllerListMembersParams,
  signal?: AbortSignal,
) => {
  return axiosClient<ListNurseryMembersResponseDto>({
    url: `/v1/members/list`,
    method: "GET",
    params,
    signal,
  });
};

export const getListNurseryMembersQueryControllerListMembersQueryKey = (
  params?: ListNurseryMembersQueryControllerListMembersParams,
) => {
  return [`/v1/members/list`, ...(params ? [params] : [])] as const;
};

export const getListNurseryMembersQueryControllerListMembersQueryOptions = <
  TData = Awaited<
    ReturnType<typeof listNurseryMembersQueryControllerListMembers>
  >,
  TError = void,
>(
  params?: ListNurseryMembersQueryControllerListMembersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listNurseryMembersQueryControllerListMembers>
        >,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListNurseryMembersQueryControllerListMembersQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listNurseryMembersQueryControllerListMembers>>
  > = ({ signal }) =>
    listNurseryMembersQueryControllerListMembers(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listNurseryMembersQueryControllerListMembers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListNurseryMembersQueryControllerListMembersQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof listNurseryMembersQueryControllerListMembers>>
  >;
export type ListNurseryMembersQueryControllerListMembersQueryError = void;

export function useListNurseryMembersQueryControllerListMembers<
  TData = Awaited<
    ReturnType<typeof listNurseryMembersQueryControllerListMembers>
  >,
  TError = void,
>(
  params: undefined | ListNurseryMembersQueryControllerListMembersParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listNurseryMembersQueryControllerListMembers>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listNurseryMembersQueryControllerListMembers>
          >,
          TError,
          Awaited<
            ReturnType<typeof listNurseryMembersQueryControllerListMembers>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListNurseryMembersQueryControllerListMembers<
  TData = Awaited<
    ReturnType<typeof listNurseryMembersQueryControllerListMembers>
  >,
  TError = void,
>(
  params?: ListNurseryMembersQueryControllerListMembersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listNurseryMembersQueryControllerListMembers>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listNurseryMembersQueryControllerListMembers>
          >,
          TError,
          Awaited<
            ReturnType<typeof listNurseryMembersQueryControllerListMembers>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListNurseryMembersQueryControllerListMembers<
  TData = Awaited<
    ReturnType<typeof listNurseryMembersQueryControllerListMembers>
  >,
  TError = void,
>(
  params?: ListNurseryMembersQueryControllerListMembersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listNurseryMembersQueryControllerListMembers>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List nursery members
 */

export function useListNurseryMembersQueryControllerListMembers<
  TData = Awaited<
    ReturnType<typeof listNurseryMembersQueryControllerListMembers>
  >,
  TError = void,
>(
  params?: ListNurseryMembersQueryControllerListMembersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listNurseryMembersQueryControllerListMembers>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getListNurseryMembersQueryControllerListMembersQueryOptions(
      params,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Returns a single nursery member by their membership ID.
 * @summary Get nursery member by ID
 */
export const getNurseryMemberQueryControllerGetMember = (
  memberId: string,
  signal?: AbortSignal,
) => {
  return axiosClient<NurseryMemberDto>({
    url: `/v1/members/${memberId}`,
    method: "GET",
    signal,
  });
};

export const getGetNurseryMemberQueryControllerGetMemberQueryKey = (
  memberId: string,
) => {
  return [`/v1/members/${memberId}`] as const;
};

export const getGetNurseryMemberQueryControllerGetMemberQueryOptions = <
  TData = Awaited<ReturnType<typeof getNurseryMemberQueryControllerGetMember>>,
  TError = void,
>(
  memberId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getNurseryMemberQueryControllerGetMember>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetNurseryMemberQueryControllerGetMemberQueryKey(memberId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getNurseryMemberQueryControllerGetMember>>
  > = ({ signal }) =>
    getNurseryMemberQueryControllerGetMember(memberId, signal);

  return {
    queryKey,
    queryFn,
    enabled: memberId !== null && memberId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getNurseryMemberQueryControllerGetMember>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetNurseryMemberQueryControllerGetMemberQueryResult = NonNullable<
  Awaited<ReturnType<typeof getNurseryMemberQueryControllerGetMember>>
>;
export type GetNurseryMemberQueryControllerGetMemberQueryError = void;

export function useGetNurseryMemberQueryControllerGetMember<
  TData = Awaited<ReturnType<typeof getNurseryMemberQueryControllerGetMember>>,
  TError = void,
>(
  memberId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getNurseryMemberQueryControllerGetMember>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNurseryMemberQueryControllerGetMember>>,
          TError,
          Awaited<ReturnType<typeof getNurseryMemberQueryControllerGetMember>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetNurseryMemberQueryControllerGetMember<
  TData = Awaited<ReturnType<typeof getNurseryMemberQueryControllerGetMember>>,
  TError = void,
>(
  memberId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getNurseryMemberQueryControllerGetMember>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNurseryMemberQueryControllerGetMember>>,
          TError,
          Awaited<ReturnType<typeof getNurseryMemberQueryControllerGetMember>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetNurseryMemberQueryControllerGetMember<
  TData = Awaited<ReturnType<typeof getNurseryMemberQueryControllerGetMember>>,
  TError = void,
>(
  memberId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getNurseryMemberQueryControllerGetMember>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get nursery member by ID
 */

export function useGetNurseryMemberQueryControllerGetMember<
  TData = Awaited<ReturnType<typeof getNurseryMemberQueryControllerGetMember>>,
  TError = void,
>(
  memberId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getNurseryMemberQueryControllerGetMember>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetNurseryMemberQueryControllerGetMemberQueryOptions(
    memberId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}
